import httpClient from "../lib/HttpClient"

export const loginHttp = async (loginDTO) => {
    return await httpClient.post("option/login",loginDTO)
}